import { useState, type FormEvent } from "react";
import { api, ApiError } from "../api.ts";
import { zsynchronizujAkcent } from "../motyw.ts";
import { useStore } from "../store.ts";
import { Ekran, Komunikat, Pole, Przycisk } from "../ui.tsx";

/**
 * Logowanie.
 *
 * Nie ma linku „załóż konto" — rejestracja istnieje wyłącznie przez link
 * zaproszeniowy od admina. To nie jest niedoróbka, tylko cała bariera wejścia
 * do aplikacji stojącej pod publiczną domeną.
 */
export function Login() {
  const setUser = useStore((state) => state.setUser);
  const [nick, setNick] = useState("");
  const [haslo, setHaslo] = useState("");
  const [blad, setBlad] = useState<string | null>(null);
  const [trwa, setTrwa] = useState(false);

  const zaloguj = async (event: FormEvent) => {
    event.preventDefault();
    setBlad(null);
    setTrwa(true);
    try {
      const { user } = await api.login(nick, haslo);
      setUser(user);
      zsynchronizujAkcent(user.kolor);
    } catch (error) {
      setBlad(error instanceof ApiError ? error.message : "Nie udało się zalogować.");
    } finally {
      setTrwa(false);
    }
  };

  return (
    <Ekran tytul="Gierki" podtytul="Gry rodzinne na telefony">
      <form onSubmit={zaloguj} className="space-y-3">
        <Pole
          value={nick}
          onChange={(event) => setNick(event.target.value)}
          placeholder="Nick"
          autoComplete="username"
          autoCapitalize="off"
          autoCorrect="off"
          enterKeyHint="next"
        />
        <Pole
          value={haslo}
          onChange={(event) => setHaslo(event.target.value)}
          placeholder="Hasło"
          type="password"
          autoComplete="current-password"
          enterKeyHint="go"
        />
        {blad ? <Komunikat rodzaj="blad">{blad}</Komunikat> : null}
        <Przycisk type="submit" wariant="glowny" pelna disabled={trwa || !nick || !haslo}>
          {trwa ? "Loguję…" : "Zaloguj"}
        </Przycisk>
      </form>

      <Komunikat>
        Konta zakłada się wyłącznie z linku zaproszeniowego. Poproś o niego kogoś, kto już gra.
      </Komunikat>

      {import.meta.env.DEV ? <SzybkieLogowanie /> : null}
    </Ekran>
  );
}

/**
 * Wejście na dowolne konto bez hasła — tylko w developmencie.
 *
 * Bez tego sprawdzenie każdej zmiany w grze dla czterech graczy wymagałoby
 * zebrania czterech osób. Trasa `/api/dev/login` nie jest w ogóle rejestrowana
 * na produkcji, więc ten panel nie ma tam czego wywołać.
 */
function SzybkieLogowanie() {
  const setUser = useStore((state) => state.setUser);
  const [nick, setNick] = useState("");

  const wejdz = async (jako: string) => {
    try {
      const { user } = await api.devLogin(jako);
      setUser(user);
      zsynchronizujAkcent(user.kolor);
    } catch {
      // W developmencie wystarczy, że nic się nie stanie.
    }
  };

  return (
    <div className="mt-8 pt-4 border-t border-obrys space-y-2">
      <div className="text-xs text-tekst-slaby uppercase tracking-wide">Tryb deweloperski</div>
      <div className="flex gap-2 flex-wrap">
        {["michal", "zosia", "kuba", "mama"].map((jako) => (
          <Przycisk key={jako} wariant="zwykly" onClick={() => void wejdz(jako)}>
            {jako}
          </Przycisk>
        ))}
      </div>
      <div className="flex gap-2">
        <Pole
          value={nick}
          onChange={(event) => setNick(event.target.value)}
          placeholder="inny nick"
        />
        <Przycisk onClick={() => void wejdz(nick)} disabled={!nick}>
          Wejdź
        </Przycisk>
      </div>
    </div>
  );
}
